<template>
    <el-dialog :modal="true" :title="'Verify Customer Contact'" :visible.sync="syncModal" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" width="560px" class="text-left">
        <div v-if="formLoading" class="p-3 text-center">Loading...</div>
        <template v-else>
            <p class="mb-2 px-2"><strong>{{ contact.name }}</strong></p>
            <table class="table table-sm mb-0">
                <tbody>
                    <tr>
                        <td style="width:80px">Mobile</td>
                        <td>{{ contact.mobile ? contact.mobile : 'Not on file' }}</td>
                        <td class="text-right" style="width:190px">
                            <span v-if="!contact.mobile">&mdash;</span>
                            <mdb-badge v-else-if="contact.verified_mobile" color="success" class="z-depth-0"><mdb-icon icon="check" /> Verified {{ formatVerifiedDate(contact.verified_mobile) }}</mdb-badge>
                            <div v-else class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="otp-channel-mobile" v-model="selected.mobile" disabled @click.prevent>
                                <label class="custom-control-label" for="otp-channel-mobile">Send OTP</label>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="selected.mobile && contact.mobile && !contact.verified_mobile">
                        <td></td>
                        <td colspan="2">
                            <div class="custom-control custom-radio d-inline-block mr-3">
                                <input type="radio" class="custom-control-input" id="otp-via-sms" value="sms" v-model="mobileVia" :disabled="sending">
                                <label class="custom-control-label" for="otp-via-sms">SMS</label>
                            </div>
                            <div class="custom-control custom-radio d-inline-block">
                                <input type="radio" class="custom-control-input" id="otp-via-whatsapp" value="whatsapp" v-model="mobileVia" :disabled="sending">
                                <label class="custom-control-label" for="otp-via-whatsapp">WhatsApp</label>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="otpSent.mobile && !contact.verified_mobile">
                        <td></td>
                        <td>
                            <input type="text" inputmode="numeric" class="form-control form-control-sm" maxlength="6" placeholder="Enter mobile OTP" v-model="otpInput.mobile" @input="otpInput.mobile = otpInput.mobile.replace(/\D/g, '')" :disabled="verifying.mobile">

                        </td>
                        <td class="text-right align-middle">
                            <mdb-btn color="elegant" size="sm" class="m-0" :disabled="verifying.mobile || otpInput.mobile.length !== 6" @click="verifyOtp('mobile')">Verify</mdb-btn>
                            <br>
                            <small><a href="javascript:void(0)" :class="{ 'text-muted' : sending }" @click="resendOtp('mobile')">Resend OTP</a></small>
                        </td>
                    </tr>
                    <tr>
                        <td>Email</td>
                        <td>{{ contact.email ? contact.email : 'Not on file' }}</td>
                        <td class="text-right">
                            <span v-if="!contact.email">&mdash;</span>
                            <mdb-badge v-else-if="contact.verified_email" color="success" class="z-depth-0"><mdb-icon icon="check" /> Verified {{ formatVerifiedDate(contact.verified_email) }}</mdb-badge>
                            <div v-else class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="otp-channel-email" v-model="selected.email" :disabled="sending">
                                <label class="custom-control-label" for="otp-channel-email">Send OTP</label>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="otpSent.email && !contact.verified_email">
                        <td></td>
                        <td>
                            <input type="text" inputmode="numeric" class="form-control form-control-sm" maxlength="6" placeholder="Enter email OTP" v-model="otpInput.email" @input="otpInput.email = otpInput.email.replace(/\D/g, '')" :disabled="verifying.email">

                        </td>
                        <td class="text-right align-middle">
                            <mdb-btn color="elegant" size="sm" class="m-0" :disabled="verifying.email || otpInput.email.length !== 6" @click="verifyOtp('email')">Verify</mdb-btn>
                            <br>
                            <small><a href="javascript:void(0)" :class="{ 'text-muted' : sending }" @click="resendOtp('email')">Resend OTP</a></small>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template slot="footer">
            <mdb-btn color="elegant" size="sm" :disabled="!canSend" @click="sendOtp()">Send OTP</mdb-btn>
            <mdb-btn color="grey" size="sm" @click="closeDialog">Close</mdb-btn>
        </template>
    </el-dialog>
</template>

<script>
import { mdbBtn, mdbBadge, mdbIcon } from 'mdbvue'
import { mapActions } from 'vuex'

export default {
    name : 'ContactVerifyDialog',
    components : {
        mdbBtn,
        mdbBadge,
        mdbIcon,
    },
    props : {
        customerId : {
            type : [Number, String],
            default : null,
        },
    },
    data(){
        return {
            syncModal : false,
            formLoading : false,
            sending : false,
            // Mobile OTP is mandatory (checkbox is default-checked and readonly in the template).
            selected : { mobile : true, email : false },
            mobileVia : 'sms',
            otpSent : { mobile : false, email : false },
            otpInput : { mobile : '', email : '' },
            verifying : { mobile : false, email : false },
            devOtp : {},
            contact : {
                name : null,
                mobile : null,
                email : null,
                verified_mobile : null,
                verified_email : null,
            },
        }
    },
    computed : {
        canSend(){
            if(this.sending || this.formLoading){
                return false
            }
            const mobileSelectable = this.selected.mobile && !!this.contact.mobile && !this.contact.verified_mobile
            const emailSelectable = this.selected.email && !!this.contact.email && !this.contact.verified_email
            return mobileSelectable || emailSelectable
        },
    },
    watch : {
        syncModal(value){
            if(value){
                this.resetState()
                this.fetchContact()
            }
        },
    },
    methods : {
        ...mapActions('ContactsModule',{
            getContactRecord : 'fetchRecord',
            sendContactOtp : 'sendContactOtp',
            verifyContactOtp : 'verifyContactOtp',
        }),
        openDialog(){
            this.syncModal = true
        },
        closeDialog(){
            this.syncModal = false
        },
        resetState(){
            this.sending = false
            this.selected = { mobile : true, email : false }
            this.mobileVia = 'sms'
            this.otpSent = { mobile : false, email : false }
            this.otpInput = { mobile : '', email : '' }
            this.verifying = { mobile : false, email : false }
            this.devOtp = {}
            this.contact = {
                name : null,
                mobile : null,
                email : null,
                verified_mobile : null,
                verified_email : null,
            }
        },
        setContact(record){
            this.contact = {
                name : record.name,
                mobile : record.mobile || null,
                email : record.email || null,
                verified_mobile : record.verified_mobile || null,
                verified_email : record.verified_email || null,
            }
        },
        formatVerifiedDate(value){
            return value ? String(value).slice(0, 10) : ''
        },
        fetchContact(){
            if(this.customerId === null){
                return
            }
            this.formLoading = true
            this.getContactRecord({ mdbID : this.customerId }).then((record) => {
                this.setContact(record)
            }).catch(() => {
                this.$ThatsNotify.warning({
                    message : 'Unable to load contact details. Please try again.',
                })
            }).finally(() => {
                this.formLoading = false
            })
        },
        sendOtp(channelsOverride){
            let channels = []
            if(Array.isArray(channelsOverride) && channelsOverride.length > 0){
                channels = channelsOverride.filter((channel) => {
                    return !!this.contact[channel] && !this.contact['verified_' + channel]
                })
            }else{
                if(this.selected.mobile && this.contact.mobile && !this.contact.verified_mobile){
                    channels.push('mobile')
                }
                if(this.selected.email && this.contact.email && !this.contact.verified_email){
                    channels.push('email')
                }
            }
            if(channels.length === 0){
                return
            }
            const payload = { id : this.customerId, channels : channels }
            if(channels.includes('mobile')){
                payload.mobile_via = this.mobileVia
            }
            this.sending = true
            this.sendContactOtp(payload).then((response) => {
                const data = response.data || {}
                const delivery = data.delivery || {}
                this.devOtp = { ...this.devOtp, ...(data.dev_otp || {}) }
                channels.forEach((channel) => {
                    this.otpSent[channel] = true
                    this.otpInput[channel] = ''
                })
                const failed = channels.filter((channel) => delivery[channel] && delivery[channel].sent === false)
                if(failed.length > 0){
                    this.$ThatsNotify.warning({
                        message : failed.map((channel) => (delivery[channel].message || `Unable to send ${channel} OTP`)).join(' '),
                    })
                }else{
                    this.$ThatsNotify.success({
                        message : 'OTP sent.',
                    })
                }
            }).catch((error) => {
                this.$ThatsNotify.warning({
                    message : (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Unable to send OTP. Please try again.',
                })
            }).finally(() => {
                this.sending = false
            })
        },
        resendOtp(channel){
            if(this.sending){
                return
            }
            this.sendOtp([channel])
        },
        verifyOtp(channel){
            this.verifying[channel] = true
            this.verifyContactOtp({ id : this.customerId, channel : channel, otp : this.otpInput[channel] }).then((response) => {
                this.setContact(response.data)
                this.selected[channel] = false
                this.otpSent[channel] = false
                this.otpInput[channel] = ''
                this.$ThatsNotify.success({
                    message : `Customer ${channel === 'mobile' ? 'mobile number' : 'email'} verified.`,
                })
                this.$emit('verified', response.data)
            }).catch((error) => {
                this.$ThatsNotify.warning({
                    message : (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Unable to verify OTP. Please try again.',
                })
            }).finally(() => {
                this.verifying[channel] = false
            })
        },
    },
}
</script>
